import { API } from "aws-amplify";

const logger = (title, body) => {
  console.log(title, body);

  const init = {
    body: {
      title,
      body: JSON.stringify(body)
    }
  };

  API.post("tiendalogger", "/log", init);
};

export default logger;
